<template>
  <div>
    <page-title heading="Pembayaran" :breadcrumb="[
        {
          label: 'Manajemen Pembayaran',
          link : '/pembayaran'
        },
        {
          label: 'Pembayaran',
          active: true
        }
      ]" />

    <div class="container-fluid">
      <div class="card card-box border-0">
        <div class="card-header border-0 py-4 px-5">
          <div class="d-flex flex-column w-100">
            <span class="text-capitalize mb-1">{{now}}</span>
            <b-row class="mb-1">
              <b-col cols="3">No. RM </b-col>
              <b-col cols="9">: {{ pembayaranList['transklinik'].pasien.nomor_rekam_medis }}</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">Nama Pasien </b-col>
              <b-col cols="9">: {{ pembayaranList['transklinik'].pasien.nama }}</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">Nama Dokter </b-col>
              <b-col cols="9">: {{ pembayaranList['created_by'].nama }}</b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">Waktu Masuk </b-col>
              <b-col cols="9">: {{ waktuMasuk  }}</b-col>
            </b-row>
          </div>
        </div>
        <div class="card-body">
          <template
            v-if="pembayaranList.status == 'BELUM LUNAS' || pembayaranList.status == 'Belum Lunas' || pembayaranList.status == 'belum lunas'">
            <h3>Belum Lunas</h3>
            <TablePembayaran @valueChanged="dataTableChanged"
              @layananDuplicateErrorState="layananDuplicateError = $event" :items="pembayaranDetails" />
          </template>
          <template
            v-if="pembayaranList.status == 'LUNAS' || pembayaranList.status == 'lunas' || pembayaranList.status == 'Lunas'">
            <h3>Lunas</h3>
            <TablePembayaran @valueChanged="dataTableChanged"
              @layananDuplicateErrorState="layananDuplicateError = $event" />
          </template>
        </div>

        <div class="card-footer">
          <div class="py-2 d-flex flex-row justify-content-end">
            <b-container fluid>
              <b-row>
                <b-col cols="6" offset="6">
                  <b-form-row class="d-flex align-items-center w-100 py-2">
                    <b-col cols="4">Total</b-col>
                    <b-col cols="8">
                      <money v-model="total" v-bind="money" class="form-control text-right" disabled />
                    </b-col>
                  </b-form-row>
                  <b-form-row class="d-flex align-items-center w-100 py-2">
                    <b-col cols="4">Diskon</b-col>
                    <b-col cols="8 mb-1">
                      <vue-select placeholder="- Pilih Jenis Diskon -" :options="['Persentase', 'Rupiah']"
                        v-model="jenis_potongan" @input="setSelected">
                      </vue-select>
                    </b-col>
                    <b-col cols="4"></b-col>
                    <b-col cols="8">
                      <template v-if="jenis_potongan === 'Persentase'">
                        <b-input-group append="%">
                          <b-form-input v-model.lazy="potongan" @keypress="isNumberPersentase($event)"
                            :disabled="assistantRole" class="text-right" />
                        </b-input-group>
                      </template>
                      <template v-if="jenis_potongan === 'Rupiah'">
                        <b-input-group append="Rp">
                          <money v-model="potongan" v-bind="money2" @keypress.native="isNumberRupiah($event)"
                            class="form-control text-right" :disabled="assistantRole" />
                        </b-input-group>
                      </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="d-flex align-items-center w-100 py-2">
                    <b-col cols="4">Total Nett</b-col>
                    <b-col cols="8">
                      <money :value="nett" v-bind="money" class="form-control text-right" disabled />
                    </b-col>
                  </b-form-row>
                  <b-form-row class="d-flex align-items-right w-100 py-2">
                    <b-col class="pt-2" align="right">
                      <b-button variant="danger" class="text-uppercase mr-3" @click="kembali" v-if="assistantRole">
                        kembali</b-button>
                      <b-button variant="success" class="text-uppercase mr-3" @click="simpanPembayaran"
                        v-if="!assistantRole">simpan</b-button>
                      <b-button variant="primary" class="text-uppercase" @click="bayarModal">bayar</b-button>
                    </b-col>
                  </b-form-row>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modalMetodePembayaran" title="Pilih Metode Pembayaran Anda" ok-only>
      <vue-select :options="['Cash']" v-model="metodePembayaran"></vue-select>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right ml-2" @click="bayarPembayaran"
            :disabled="!metodePembayaran">
            Lanjutkan Pembayaran
          </b-button>
          <b-button variant="danger" size="sm" class="float-right" @click="$bvModal.hide('modalMetodePembayaran')">
            Batal
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {
    mapMutations,
    mapGetters
  } from "vuex";
  import startCase from "lodash/startCase";
  
  import moment from "moment";
  moment.locale('id');
  import {
    Money
  } from 'v-money';

  export default {
    components: {
      TablePembayaran: () => import("./TablePembayaran.vue"),
      "vue-select": () => import("vue-select"),
      Money
    },
    data: () => ({
      money: {
        decimal: "",
        thousands: ",",
        prefix: "Rp. ",
        suffix: "",
        precision: 0,
        masked: false
      },
      money2: {
        decimal: "",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: "",
        masked: false
      },
      pembayaranList: [],
      total: null,
      jenis_potongan: null,
      nett: null,
      potongan: null,
      pembayaranVal: null,
      pembayaranDetails: [],
      postData: {
        pembayaran_id: null,
        total: 0,
        potongan: 0,
        total_nett: 0,
        jenis_potongan: null,
        detail_pembayaran: []
      },
      metodePembayaran: 'Cash',
      layananDuplicateError: false,
      dataTable: []
    }),
    computed: {
      ...mapGetters(["assistantRole"]),
      now() {
        return moment().format('dddd' + ', ' + "Do MMMM YYYY");
      },
      waktuMasuk() {
        return moment(this.pembayaranList.created_at).format("Do MMMM YYYY HH:mm");
      }
    },
    watch: {
      jenis_potongan(newVal) {
        this.postData.jenis_potongan = newVal;
        this.calcDataTable()
      },
      potongan(newVal) {
        if (!newVal) {
          this.potongan = '';
        }
        this.postData.potongan = newVal;
        this.calcDataTable()
      },
    },
    mounted() {
      this.fetchGetPembayaran();
    },
    beforeRouteLeave(to, from, next) {
      next();
    },
    methods: {
      ...mapMutations({
        setStrukVal: "struk/SET_STRUK_VAL"
      }),
      setSelected(value) {
        let val = value;
        this.potongan = 0;
      },
      isNumberPersentase: function (evt) {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if (key.length == 0) return;
        var regex = /^[0-9,\b]+$/;
        if (!regex.test(key)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }

        let regex2 = /^[0-9]*(,[0-9]{0,2})?$/;
        if (regex2.test(this.potongan + evt.key) == false || parseInt(this.potongan + evt.key) > 100 || parseInt(this
            .potongan + evt.key) < 0) {
          evt.preventDefault();
        }
        return true;
      },
      isNumberRupiah: function (evt) {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if (key.length == 0) return;
        var regex = /^[0-9\b]+$/;
        if (!regex.test(key)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }

        if (parseInt(this.potongan + evt.key) > this.total || parseInt(this.potongan + evt.key) < 0) {
          evt.preventDefault();
        }

        return true;
      },
      calc(val) {
        let total_tmp = 0;
        let detail_pembayaran = [];

        val.forEach(item => {
          total_tmp += item.quantity * item.tarif;
          detail_pembayaran.push({
            kode_layanan: item.kode_layanan,
            nama_layanan: item.nama_layanan.nama_layanan,
            tarif: item.tarif,
            quantity: item.quantity,
          })
        });

        this.total = total_tmp;

        this.postData.pembayaran_id = this.pembayaranList.id;
        this.postData.jenis_potongan = this.jenis_potongan;
        this.postData.detail_pembayaran = detail_pembayaran;
        this.postData.total = this.total;

        let harga_diskon = 0;
        if (this.jenis_potongan == 'Persentase') {
          let fl = parseFloat((this.potongan + '').replace(',', '.'))
          harga_diskon = ((fl / 100) * this.total);
        } else if (this.jenis_potongan == 'Rupiah') {
          harga_diskon = this.potongan;
        }
        this.nett = this.total - harga_diskon;
        this.postData.total_nett = this.nett;
      },
      bayarModal() {
        let detPem = this.postData.detail_pembayaran;
        let status = [];
        var isRoute = this.$router.currentRoute.params.bayar_id;

        detPem.forEach(item => {
          if (item.kode_layanan == '') {
            status.push(false);
            this.$swal({
              type: "error",
              title: startCase("gagal"),
              text: startCase("Seluruh kolom harus diisi!")
            });
          } else {
            status.push(true);
          }
        });

        if (this.layananDuplicateError) {
          this.$swal({
            type: "error",
            title: startCase("gagal"),
            text: startCase("Layanan Tidak Boleh Sama")
          });
          return;
        }

        if (status.indexOf(false) < 0) {

          if (this.postData.jenis_potongan != null) {
            this.postData.jenis_potongan = this.postData.jenis_potongan.toUpperCase();
          }

          this.$axios.post(`pembayaran/detail`, this.postData)
            .then((res) => {
              if (!res.data.status && res.data.data == "duplicate tarif") {
                this.$swal({
                  text: 'Layanan Tidak Boleh Sama',
                  icon: 'warning',
                  confirmButtonText: startCase("ya")
                });
              } else if (!res.data.status && res.data.data == "invalid tarif") {
                this.$swal({
                  text: 'Telah terdapat perubahan pada layanan di halaman pembayaran Anda. Silakan cek ulang sebelum menyelesaikan pembayaran Anda!',
                  icon: 'warning',
                  confirmButtonText: startCase("OK")
                }).then(res => {
                  if (res.value) {
                    this.$router.go({
                      name: "pembayaran-tambah",
                      params: {
                        bayar_id: isRoute
                      }
                    });
                  }
                });
              } else {
                this.$swal({
                  title: startCase("Bayar"),
                  text: `Apakah Anda yakin untuk melakukan pembayaran?`,
                  type: "warning",
                  showCancelButton: true,
                  cancelButtonText: startCase("tidak"),
                  confirmButtonText: startCase("ya")
                }).then(res => {
                  if (res.value) {
                    this.$bvModal.show('modalMetodePembayaran');
                    // TODO: tampil popup pilihan metode pembayaran
                  }
                });
              }
            }).catch((error) => {
              this.$swal({
                type: "error",
                title: startCase("gagal"),
                text: startCase("Pembayaran Gagal")
              }).then(res => {
                if (res.value) {
                  this.$router.go({
                    name: "pembayaran-tambah",
                    params: {
                      bayar_id: isRoute
                    }
                  });
                }
              });
            });
        }
      },
      previewStruk() {
        this.setStrukVal(this.pembayaranVal);
        this.$router.push({
          name: "pembayaran-struk"
        });
      },
      async fetchGetPembayaran() {
        try {
          var isRoute = this.$router.currentRoute.params.bayar_id;
          const res = await this.$axios.get(
            `pembayaran/${isRoute}`
          );
          const {
            status,
            data
          } = res.data;

          if (status == false || data.status == "LUNAS") {
            this.$router.push({
              name: "pembayaran-list"
            })
          }

          this.pembayaranList = data;
          if (data.jenis_potongan) {
            let s = data.jenis_potongan;
            this.jenis_potongan = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
          }
          this.potongan = data.potongan;

          data.detail.forEach((item, i) => {
            this.pembayaranDetails.push({
              no: i + 1,
              kode_layanan: item.kode_layanan,
              nama_layanan: item.nama_layanan,
              tarif: item.tarif,
              quantity: item.quantity,
              subtotal: item.subtotal_tarif
            })
          })

          this.calc(this.pembayaranList)
        } catch (err) {
        }
      },
      simpanPembayaran() {
        let detPem = this.postData.detail_pembayaran;
        let status = [];
        var isRoute = this.$router.currentRoute.params.bayar_id;

        detPem.forEach(item => {

          if (this.layananDuplicateError) {
            status.push(false);
            this.$swal({
              type: "error",
              title: startCase("gagal"),
              text: startCase("Layanan Tidak Boleh Sama")
            });
          } else {
            status.push(true);
          }

          if (item.kode_layanan == '') {
            status.push(false);
            this.$swal({
              type: "error",
              title: startCase("gagal"),
              text: startCase("Seluruh kolom harus diisi!")
            });
          } else {
            status.push(true);
          }
        });

        if (status.indexOf(false) < 0) {
          this.$axios.post(`pembayaran/detail`, this.postData)
            .then((res) => {
              const {
                success,
                data
              } = res.data;
              this.pembayaranList = data;
              if (!res.data.status && res.data.data == "duplicate tarif") {
                this.$swal({
                  text: 'Layanan Tidak Boleh Sama',
                  icon: 'warning',
                  confirmButtonText: startCase("ya")
                });
              } else if (!res.data.status && res.data.data == "invalid tarif") {
                this.$swal({
                    text: 'Telah terdapat perubahan pada layanan di halaman pembayaran Anda. Silakan cek ulang sebelum menyelesaikan pembayaran Anda!',
                    icon: 'warning',
                    confirmButtonText: startCase("OK")
                  })
                  .then(res => {
                    if (res.value) {
                      this.$router.go({
                        name: "pembayaran-tambah",
                        params: {
                          bayar_id: isRoute
                        }
                      });
                    }
                  });
              } else {
                this.$swal({
                  title: 'Tambah Data Berhasil',
                  text: 'Data berhasil tersimpan',
                  icon: 'success',
                  confirmButtonText: startCase("ya")
                });
                this.$router.push({
                  path: "/pembayaran"
                });
              }
            })
            .catch((error) => {
              this.$swal({
                  text: 'Telah terdapat perubahan pada layanan di halaman pembayaran Anda. Silakan cek ulang sebelum menyelesaikan pembayaran Anda!',
                  icon: 'warning',
                  confirmButtonText: startCase("OK")
                })
                .then(res => {
                  if (res.value) {
                    this.$router.go({
                      name: "pembayaran-tambah",
                      params: {
                        bayar_id: isRoute
                      }
                    });
                  }
                });
            });
        }
      },
      bayarPembayaran() {
        this.$bvModal.hide('modalMetodePembayaran');
        
        if (this.postData.jenis_potongan != null) {
          this.postData.jenis_potongan = this.postData.jenis_potongan.toUpperCase();
        }

        //proses bayar
        this.$axios.post(`pembayaran/detail`, this.postData)
          .then((res) => {
            if (!res.data.status && res.data.data == "duplicate tarif") {
              this.$swal({
                text: 'Layanan Tidak Boleh Sama',
                icon: 'warning',
                confirmButtonText: startCase("ya")
              });
            } else if (!res.data.status && res.data.data == "invalid tarif") {
              this.$swal({
                text: 'Telah terdapat perubahan pada layanan di halaman pembayaran Anda. Silakan cek ulang sebelum menyelesaikan pembayaran Anda!',
                icon: 'warning',
                confirmButtonText: startCase("OK")
              });
            } else {
              this.$axios.put(
                `pembayaran/${this.pembayaranList.id}`, {
                  status: "LUNAS"
                }
              );

              this.$swal({
                title: 'Pembayaran Berhasil',
                icon: 'success',
                confirmButtonText: startCase("ya")
              });
              this.$router.push(`/pembayaran/struk/${this.pembayaranList.id}`)
            }
          }).catch((error) => {
            this.$swal({
              title: 'Gagal',
              text: 'Pembayaran tidak berhasil',
              icon: 'warning',
              confirmButtonText: startCase("ya")
            });
          });
      },
      kembali() {
        this.$router.push({
          name: 'pembayaran-list'
        });
      },
      dataTableChanged(data) {
        this.dataTable = data;
        this.calcDataTable()
      },
      calcDataTable() {
        this.calc(this.dataTable)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .card {
    .card-header {
      background-color: #eaf9e6;
    }
  }
</style>